import { GaugeChartPropsBase } from '../../../core';
import { BasePanelProps, useDataQueryResult } from '../../../plugin-system';
import { BarGaugeChartPanelLoaded } from './BarGaugeChartPanelLoaded';
import { GaugeChartPanelLoaded } from './GaugeChartPanelLoaded';

/**
 * Types for the pie chart that are only used in the `Viz` variant.
 *
 * @see {@link GaugeChartPropsBase} for types defined in the schema because they are also shared with
 * the `DashboardPanel` variant.
 */
interface GaugeChartPropsVizOnly {
  // Currently no Viz only props, but leaving this here, so it is clear where to put them in the future.
}

export interface GaugeChartPanelProps extends BasePanelProps, GaugeChartPropsBase, GaugeChartPropsVizOnly {
  // Extend values from `GaugeChartPropsBase` below, as needed, to add in jsdoc to help developers.
}

export function GaugeChartPanel(props: GaugeChartPanelProps) {
  const { width, height, mode } = props;

  const contentDimensions = width && height ? { width, height } : undefined;

  const { queryResults } = useDataQueryResult({ dataTypeFilter: 'SingleValue' });

  if (queryResults[0]?.error) throw queryResults[0]?.error;

  if (contentDimensions === undefined) return null;

  if (mode === 'Bar') {
    return <BarGaugeChartPanelLoaded {...props} contentDimensions={contentDimensions} />;
  }

  return <GaugeChartPanelLoaded {...props} contentDimensions={contentDimensions} />;
}
